import React, {FC} from 'react';
import styles from './WorkingWithTIC.module.scss';
import Stack from '@mui/material/Stack';
import Team from "../../../assets/images/ticTeam.jpg";
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import {Helmet} from "react-helmet";

interface WorkingWithTicProps {
}

const WorkingWithTic: FC<WorkingWithTicProps> = () => (

    <>
        <Helmet>
        <meta charSet="utf-8"/>
        <title>Working with TIC</title>
    </Helmet>
        <div className={styles.WorkingWithTic}>
            <div className="standard-margin">
                <h1>Working with the Technical Information Center</h1>
                <hr></hr>
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={2}
                >

                    <span><h3>Drawings Sent for Archival and Inclusion</h3>

                        <p>Turn-around time for items sent to TIC (Technical Information Center) vary — we can scan 300 to 500 drawings per week.Parks sending0, <b>more than 30 drawing sets need to contact TIC staff before sending</b> to be placed in the queue.<br></br><br></br>
                            <b>Materials should be sent via FedEx Overnight</b> to ensure single point handling of materials and to reduce lost or missing shipments. <br></br><br></br>


                            <b> Senders need to provide TIC with tracking numbers </b>to ensure proper delivery, we cannot guarantee receipt of delivery without tracking numbers. TIC cannot ship back materials to a P.O. Box and will require a street address to return materials.<br></br><br></br>
                                                  </p>
                    </span>

                    <span>
                        <a href={require('../../../assets/images/ticTeam.jpg')} target="_blank">
                            <img src={Team} alt="team" className={styles.team}/></a></span>
                </Stack>

                <span>
                    <p>
                          Items in electronic form can be uploaded directly by using our File Upload feature.
                            <br></br><br></br>
                            Should you have any questions, including where to send, please visit our &nbsp;
                        <Link to={"./../Teams"}>
                                Contact Us
                            </Link> page.
                        TIC will use current drawing numbers on legacy drawings. If drawings do not have a drawing number, one will be assigned at the time of cataloging.<br></br>

                        <ol>
                            <li><b>Locate the drawing log book for your park, which lists the drawing numbers already in use.</b> Procedures for assigning drawing numbers, the format for the title block on drawings and illustrations such as where to place the drawing numbers are described in the handbooks for Director’s Order 10A and Director’s Order 10B. The drawing numbers include a 3 digit park code over a drawing number: example: 123/123456. It's the park’s responsibility to contact TIC to assign numbers to the drawings or documents. Another option is to use numbers.nps.gov to assign them online.</li>
                            <br></br>
                            <li><b>Compare the list of drawings for your park in eTIC2 with your drawing log book.</b> Contact TIC to set up access to drawings identified as “sensitive” or “archeological”. This will allow you to see all of the drawings for your park, including water systems, HVAC (heating, ventilation, and air conditioning) systems, and archeological information.</li>
                            <br></br>
                            <li><b>Prepare any drawings not listed in eTIC2 for shipment to TIC.</b> Verify that each drawing sheet has a clearly visible drawing number (usually located in the lower right corner) — a medium point permanent marker should be used for drawings lacking this information.</li>
                            <br></br>
                            <li><b>Pack your drawings securely.</b> Use packing material to prevent shifting and a core tube to roll the drawings around in order to prevent crushing during shipment. Contact TIC if your drawings are standard size (24 inches x 36 inches) and you would like flat map boxes for shipping. We recommend using FedEx 2nd or 3rd day shipping.</li>
                        </ol>

                        TIC will index the Facility Management Software System (FMSS) asset/location numbers only when this information is included on the drawings or listed in either a transmittal letter to TIC or included as part of the inventory.
                        <br></br>
                        The park should include an inventory of the shipment and a transfer of property. Transfer of property paperwork can be obtained by contacting TIC and is required if we are to keep and archive the materials.
                        <br></br>
                        TIC accepts and stores AutoCAD files. Contact TIC for specific information regarding accepted electronic formats.
                        <br></br>
                        TIC Record Management Support Services for NPS Park Units
                        Upon request, the Technical Information Center provides records management support services to NPS park units. The support services include cataloging and records surveying assessment. The purpose of the records survey is to identify and quantify all records created and maintained by the park unit, and to analyze the functions of the record office or department. As such, meeting with the requestor and any other personnel to learn their current records management program may be necessary. Through conversations and observation, the task is to gather and document detailed information.
                        <br></br>
                        The points of observation should:
                        <ul className={styles.black}>
                            <li>  Identify the records that document how the office/department functions.</li>
                            <li> Survey any records that exist in a repository and offices.</li>
                            <li> Determine if a records management program exists that demonstrates the creation, maintenance, use, and disposition of records.</li>
                            <li> Determine if there are immediate needs, such as transferring records to the archives or destruction.</li>
                        </ul>
                        Please send inquiries regarding records surveys to etic@nps.gov.
                    </p>
                </span>
                <br></br>
            </div>
        </div>
    </>

);

export default WorkingWithTic;
